import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-playstore',
  standalone: true,
  templateUrl: '../../assets/playstore.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamPlaystoreIcon {}
